import axiosClient from "../../../shared/lib/axiosClient";
import { BLOG_API_BASE } from "../../../shared/utils/apiConfig";
import type { BlogListResponse, BlogPost, BlogPostResponse, BlogSummary } from "../types";

export const BLOGS_PER_PAGE = 12;

export interface BlogPage {
    blogs: BlogSummary[];
    totalPages: number;
}

// One page of posts in the given language (page is 1-based)
export const getBlogs = async (
    language: string,
    page: number,
    signal?: AbortSignal
): Promise<BlogPage> => {
    const { data } = await axiosClient.get<BlogListResponse>(BLOG_API_BASE, {
        params: { language, page, limit: BLOGS_PER_PAGE },
        signal
    });

    // An unexpected response is an error, not an empty list
    if (!Array.isArray(data?.data)) {
        throw new Error("Unexpected response from the blog endpoint");
    }

    return { blogs: data.data, totalPages: data.pagination?.totalPages ?? 0 };
};

// Returns null when the post doesn't exist
export const getBlogPost = async (
    slug: string,
    language: string,
    signal?: AbortSignal
): Promise<BlogPost | null> => {
    const { data } = await axiosClient.get<BlogPostResponse>(`${BLOG_API_BASE}/${slug}`, {
        params: { language },
        signal
    });

    return data.post ?? null;
};